
export function formatDeliveryId(id: number): string {
    return `#DL-${id.toString().padStart(3, '0')}`;
}

export default formatDeliveryId;
